import { FC } from "react";
import { Navigate, Route, Routes, type Location } from "react-router-dom";

import {
  KanbanWrapper,
  RidesCalendar,
  RidesCardBoard,
  RidesGridMultiSelect,
  RidesGridSingleSelect,
} from "../search";
import { useRidesViewSwitchPane } from "./use-rides-view-switch-pane";

interface IRidesViewSwitchPaneProps {
  location: Location;
  navigateToSegment: string;
  paneViewKey: string;
}

export const RidesViewSwitchPane: FC<IRidesViewSwitchPaneProps> = ({
  location,
  navigateToSegment,
  paneViewKey,
}) => {
  const { routesLocation } = useRidesViewSwitchPane({ location, paneViewKey });

  return (
    <Routes location={routesLocation}>
      <Route path="card-board/*" element={<RidesCardBoard />} />
      <Route path="kanban/*" element={<KanbanWrapper />} />
      <Route path="grid/*" element={<RidesGridMultiSelect />} />
      <Route path="table/*" element={<RidesGridSingleSelect />} />
      <Route path="calendar/*" element={<RidesCalendar />} />
      <Route path="/*" element={<Navigate to={navigateToSegment} />} />
    </Routes>
  );
};
